import { scaleTime, scaleLinear } from 'd3-scale';

const initialState = {
  brushDomain: [],
  marginLeft: 0,
  scales: {
    x: scaleTime(),
    y: scaleLinear(),
    x2: scaleTime(),
    y2: scaleLinear(),
  },
  svgDimensions: {
    width: 0,
    height: 0,
  },
  focusDimensions: {
    width: 0,
    height: 0,
  },
  contextDimensions: {
    width: 0,
    height: 0,
  },
  focusMargins: {
    top: 0,
    right: 0,
    bottom: 0,
  },
  contextMargins: {
    top: 0,
    right: 0,
    bottom: 0,
  },
  loaderVisibility: 'visible',
  tooltipData: {
    data: [],
    mousePositions: [0, 0],
    visibility: 'hidden',
  },
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'SET_BRUSH_DOMAIN':
      return {
        ...state,
        brushDomain: payload,
      };
    case 'SET_SCALES':
      return {
        ...state,
        scales: payload,
      };
    case 'SET_SVG_DIMENSIONS':
      return {
        ...state,
        svgDimensions: payload,
      };
    case 'SET_MARGIN_LEFT':
      return {
        ...state,
        marginLeft: payload,
      };
    case 'SET_FOCUS_DIMENSIONS':
      return {
        ...state,
        focusDimensions: payload,
      };
    case 'SET_CONTEXT_DIMENSIONS':
      return {
        ...state,
        contextDimensions: payload,
      };
    case 'SET_FOCUS_MARGINS':
      return {
        ...state,
        focusMargins: payload,
      };
    case 'SET_CONTEXT_MARGINS':
      return {
        ...state,
        contextMargins: payload,
      };
    case 'SHOW_LOADER':
      return {
        ...state,
        loaderVisibility: payload,
      };
    case 'HIDE_LOADER':
      return {
        ...state,
        loaderVisibility: payload,
      };
    case 'TOOLTIP_DATA':
      return {
        ...state,
        tooltipData: payload,
      };
    case 'RESET_CHART':
      return { ...initialState };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/app/reducers/chart-reducer.js